import React from "react";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import EditInternal from "customComponents/devicesComponents/EditInternal";

import Moment from "react-moment";
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

import { useSelector } from "react-redux";
import { canEditOrder } from "../../../utils/permissions";

export default function InternalTable({ device, user }) {
  const currentOrder = useSelector((state) => state.orders.currentOrder);
  const canEdit = canEditOrder(user, currentOrder);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const contractColumns = [
    { Header: "Étude de sécurité", accessor: "safety_date", align: "center" },
  ];
  const contractRows = [
    {
      safety_date: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {device && device.safety_study_date !== null ? (
            <MDBox lineHeight={1}>
              <MDTypography variant="caption">Réalisée le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">{device && device.safety_study_date}</Moment>
              </MDTypography>
            </MDBox>
          ) : (
            <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
              Non réalisée
            </MDTypography>
          )}
        </MDBox>
      ),
    },
  ];
  return (
    <Grid item lg={12} md={12} sm={12} xs={12} height="100%">
      <Card sx={{ height: "100%" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          sx={{
            background: !darkMode ? "linear-gradient(195deg, #364c70, #273956)" : "white",
            boxShadow: darkMode ? "0 1px 4px 1px white" : "0 1px 4px 1px #344767",
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <MDTypography
            variant="h5"
            style={{
              width: "75%",
              lineHeight: "2.4rem",
              display: "tableCell",
              verticalAlign: "middle",
            }}
            color={darkMode ? "inherit" : "white"}
          >
            Sécurité
          </MDTypography>
          {canEdit && (
              <Grid style={{ textAlign: "right", width: "25%" }}>
                <EditInternal device={device} edit={true} renderStep={0} />
              </Grid>
            )}
        </MDBox>
        <MDBox
          pt={0.75}
          sx={{
            height: "100%",
            "div.MuiTableContainer-root": {
              height: "100%",
              display: "flex",
            },
          }}
        >
          <DataTable
            table={{ columns: contractColumns, rows: contractRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>
      </Card>
    </Grid>
  );
}
